export default __webpack_public_path__ + "static/media/learners.2ef1a916.png";